import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../Buttons/Button";

import usersService from "../../../../../services/userService";

import { MainLogo } from "../../../../../assets";

function ParentHeaderNavMobile({
  userInfo,
  setOpenNavParentProfileMenu,
  openNavParentProfileMenu,
}) {
  const { t } = useTranslation();

  return (
    <>
      {!openNavParentProfileMenu ? (
        <nav>
          <ul>
            <li>
              <img className="userAvatar" src={MainLogo} alt={userInfo?.name} />
            </li>
            <li>
              <Button
                label={t("dashboard")}
                iconClassName="hasIcon--grid"
                viewType="noBorder"
                onClick={() => usersService.goToMonolith("dashboard/")}
              />
            </li>
            <li>
              <Button
                label={t("myProfile")}
                iconClassName="hasIcon--edit"
                viewType="noBorder"
                onClick={() => setOpenNavParentProfileMenu(true)}
              />
            </li>
            <li>
              <Button
                label={t("notifications")}
                iconClassName="hasIcon--mail"
                viewType="noBorder"
                onClick={() => usersService.goToMonolith("notifications/all/")}
              />
              {userInfo?.notifications?.count > 0 && (
                <div className="menu-counter">
                  {userInfo?.notifications?.count}
                </div>
              )}
            </li>
            <li>
              <Button
                label={t("library")}
                iconClassName="hasIcon--book-open"
                viewType="noBorder"
                onClick={() => usersService.goToMonolith("moms-library/")}
              />
            </li>
            <li>
              <a
                href="https://bluemanoreducation.com/product-category/blue-manor-print-books/"
                target="_blank"
                rel="noreferrer noopener"
                className="noBorder asLink hasIcon--shopping-cart"
                title={t("bookStore")}
              >
                {t("shop")}
              </a>
            </li>
          </ul>
        </nav>
      ) : (
        <nav>
          <ul>
            <li><p className="secondNavTitle">{userInfo?.name}</p></li>
            <li>
              <Button
                label={t("editProfile")}
                iconClassName="hasIcon--edit"
                viewType="noBorder"
                onClick={() =>
                  usersService.goToMonolith(`accounts/users/profile/`)
                }
              />
            </li>
            <li>
              <Button
                label={t("billing")}
                iconClassName="hasIcon--credit-card"
                viewType="noBorder"
                onClick={() => usersService.goToMonolith("accounts/payment/")}
              />
            </li>
          </ul>
          <Button
            label={t("logout")}
            iconClassName="hasIcon--log-out"
            viewType="noBorder"
            customClassName="goToParentCustom"
            onClick={() => usersService.goToMonolith("accounts/logout/?next=/")}
          />
        </nav>
      )}
    </>
  );
}

export default ParentHeaderNavMobile;
